import { LoadingState } from "@material-dev/insights-portal-ui-components/lib/types";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IProjectsClient, ProjectsClient } from "app/ApiClient";
import { EncodedDataClient, IEncodedDataClient } from "app/SharedApiClient";
import { BASE_SHARED_API_URL } from "const/baseUrl";
import { initialCompareVersionState } from "./compareVersionsState";

const encodedDataSharedClient: IEncodedDataClient = new EncodedDataClient(BASE_SHARED_API_URL);
const projectsClient: IProjectsClient = new ProjectsClient(process.env.REACT_APP_API_URL);
 

export const getProjectByReferenceProjectId = createAsyncThunk(
  "compareVersions/getProjectByReferenceProjectId",
  async (originProjectId: string, { rejectWithValue }) => {
    try {
      const result = await projectsClient.getProjectByOriginProjectId(originProjectId);
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getProjectByComparatorProjectId = createAsyncThunk(
  "compareVersions/getProjectByComparatorProjectId",
  async (originProjectId: string, { rejectWithValue }) => {
    try {
      const result = await projectsClient.getProjectByOriginProjectId(originProjectId);
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getReferenceProjectEncodingVersions = createAsyncThunk(
  "compareVersions/getReferenceProjectEncodingVersions",
  async ({ originProjectId, source }: { originProjectId: string; source: string }, { rejectWithValue }) => {
    try {
      const result = await encodedDataSharedClient.getEncodedVersions(originProjectId, source);
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getComparatorProjectEncodingVersions = createAsyncThunk(
  "compareVersions/getComparatorProjectEncodingVersions",
  async ({ originProjectId, source }: { originProjectId: string; source: string }, { rejectWithValue }) => {
    try {
      const result = await encodedDataSharedClient.getEncodedVersions(originProjectId, source);
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const compareVersionsSlice = createSlice({
  initialState: initialCompareVersionState,
  name: "compareVersions",
  reducers: {
    resetCompareVersions: () => initialCompareVersionState,
  },
  extraReducers: (builder) => {
     
    // getProjectByComparatorProjectId
    builder.addCase(getProjectByComparatorProjectId.pending, (state) => {
      state.comparatorProject = null;
      state.comparatorLoading = LoadingState.pending;
    });
    builder.addCase(getProjectByComparatorProjectId.fulfilled, (state, { payload }) => {
      state.comparatorProject = payload;
      state.comparatorLoading = LoadingState.succeed;
    });
    builder.addCase(getProjectByComparatorProjectId.rejected, (state) => {
      state.comparatorLoading = LoadingState.failed;
    });

    // getProjectByReferenceProjectId
    builder.addCase(getProjectByReferenceProjectId.pending, (state) => {
      state.referenceProject = null;
      state.referenceLoading = LoadingState.pending;
    });
    builder.addCase(getProjectByReferenceProjectId.fulfilled, (state, { payload }) => {
      state.referenceProject = payload;
      state.referenceLoading = LoadingState.succeed;
    });
    builder.addCase(getProjectByReferenceProjectId.rejected, (state) => {
      state.referenceLoading = LoadingState.failed;
    });

    // getReferenceProjectEncodingVersions
    builder.addCase(getReferenceProjectEncodingVersions.pending, (state) => {
      state.referenceEncodingVersions = [];
      state.referenceLoading = LoadingState.pending;
    });
    builder.addCase(getReferenceProjectEncodingVersions.fulfilled, (state, { payload }) => {
      state.referenceEncodingVersions = payload;
      state.referenceLoading = LoadingState.succeed;
    });
    builder.addCase(getReferenceProjectEncodingVersions.rejected, (state) => {
      state.referenceLoading = LoadingState.failed;
    });

    // getComparatorProjectEncodingVersions
    builder.addCase(getComparatorProjectEncodingVersions.pending, (state) => {
      state.comparatorEncodingVersions = [];
      state.comparatorLoading = LoadingState.pending;
    });
    builder.addCase(getComparatorProjectEncodingVersions.fulfilled, (state, { payload }) => {
      state.comparatorEncodingVersions = payload;
      state.comparatorLoading = LoadingState.succeed;
    });
    builder.addCase(getComparatorProjectEncodingVersions.rejected, (state) => {
      state.comparatorLoading = LoadingState.failed;
    });
  },
});

export const { resetCompareVersions } = compareVersionsSlice.actions;
export default compareVersionsSlice.reducer;
